import React, { useEffect, useRef, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import {
    Box, Typography, Button, IconButton,
    Card, CardContent, CircularProgress
} from '@mui/material';
import { ArrowBack, FullscreenExit } from '@mui/icons-material';
import AgoraRTC from 'agora-rtc-sdk-ng';

const StudentFullView = () => {
    const { examId, studentId } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);
    const videoRef = useRef(null);
    const clientRef = useRef(null);

    useEffect(() => {
        const initAgora = async () => {
            const client = AgoraRTC.createClient({ mode: 'rtc', codec: 'vp8' });
            clientRef.current = client;

            try {
                await client.join(
                    'YOUR_AGORA_APP_ID',
                    `exam-proctor-${examId}`,
                    null, // token
                    null  // uid
                );

                client.on('user-published', async (user, mediaType) => {
                    if (user.uid === studentId) {
                        await client.subscribe(user, mediaType);
                        setUser({
                            ...user,
                            hasVideo: mediaType === 'video',
                            hasAudio: mediaType === 'audio'
                        });
                        setLoading(false);
                    }
                });

                client.on('user-unpublished', (unpublishedUser) => {
                    if (unpublishedUser.uid === studentId) {
                        setUser(null);
                    }
                });

            } catch (error) {
                console.error('Agora initialization failed:', error);
                setLoading(false);
            }
        };

        initAgora();

        return () => {
            if (clientRef.current) {
                clientRef.current.leave();
            }
        };
    }, [examId, studentId]);

    useEffect(() => {
        if (videoRef.current && user?.videoTrack) {
            user.videoTrack.play(videoRef.current);
        }

        return () => {
            if (videoRef.current) {
                videoRef.current.srcObject = null;
            }
        };
    }, [user]);

    const handleBack = () => {
        navigate(`/proctor-dashboard/${examId}`);
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" minHeight="80vh">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box sx={{ height: '100vh', overflow: 'hidden' }}>
            {/* Header */}
            <Box sx={{
                p: 2,
                bgcolor: 'background.paper',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                position: 'fixed',
                width: '100%',
                zIndex: 1000,
                boxShadow: 1
            }}>
                <Button
                    startIcon={<ArrowBack />}
                    onClick={handleBack}
                >
                    Back to dashboard
                </Button>

                <Typography variant="h6">
                    Proctoring: Student {studentId}
                </Typography>
            </Box>

            {/* Main Content */}
            <Box sx={{
                pt: 8,
                height: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            }}>
                {user?.hasVideo ? (
                    <Card sx={{ width: '90%', height: '90%' }}>
                        <video
                            ref={videoRef}
                            autoPlay
                            playsInline
                            style={{
                                width: '100%',
                                height: '100%',
                                objectFit: 'contain',
                                backgroundColor: '#000'
                            }}
                        />
                    </Card>
                ) : (
                    <Card sx={{
                        width: '90%',
                        height: '90%',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center'
                    }}>
                        <Typography variant="h6" color="textSecondary">
                            Student camera is not available
                        </Typography>
                    </Card>
                )}
            </Box>
        </Box>
    );
};

export default StudentFullView;